var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("el-card", [
    _c(
      "div",
      { staticClass: "clearfix", attrs: { slot: "header" }, slot: "header" },
      [
        _c("span", { staticClass: "header-item" }, [
          _vm._v(_vm._s(_vm.location.name) + " "),
        ]),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "card-content" },
      [
        _c(
          "el-row",
          { attrs: { gutter: 20 } },
          [
            _c("el-col", { attrs: { span: 8 } }, [
              _c("div", { staticClass: "ring-card__title" }, [
                _vm._v("\n          Address\n        "),
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "address-row location-description" }, [
                _c("i", { staticClass: "el-icon-location" }),
                _vm._v(" " + _vm._s(_vm.locationAddress) + "\n        "),
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "address-row location-timezone" }, [
                _c("i", { staticClass: "el-icon-time" }),
                _vm._v(
                  " " +
                    _vm._s(_vm.location.address.timezone || "No information") +
                    "\n        "
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "ring-card__title" }, [
                _vm._v("\n          Location Owner\n        "),
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "address-row location-owner" }, [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.owner.email || "No Owner") +
                    "\n        "
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "ring-card__title" }, [
                _vm._v("\n          Location ID\n        "),
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "address-row location-id" }, [
                _vm._v("\n          " + _vm._s(_vm.locationId) + "\n        "),
              ]),
              _vm._v(" "),
              _vm.showModeSchedules
                ? _c(
                    "div",
                    {
                      staticClass: "address-row",
                      attrs: { "data-test-id": "mode-schedules-url" },
                    },
                    [
                      _c(
                        "a",
                        {
                          attrs: {
                            href: _vm.location["mode_schedules_url"],
                            target: "_blank",
                          },
                        },
                        [_vm._v("View Mode Schedules")]
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.sos.enabled
                ? _c("div", { staticClass: "ring-card__title" }, [
                    _c(
                      "a",
                      {
                        attrs: {
                          href: _vm.sos.ring_alarm_url,
                          target: "_blank",
                        },
                      },
                      [_vm._v(" SOS Enabled ")]
                    ),
                  ])
                : _vm._e(),
            ]),
            _vm._v(" "),
            _c(
              "el-col",
              { attrs: { span: 8 } },
              [
                _c("div", { staticClass: "ring-card__title" }, [
                  _vm._v("\n          Users\n        "),
                ]),
                _vm._v(" "),
                _vm._l(_vm.ownerUsers, function (user) {
                  return _c(
                    "div",
                    {
                      key: user.user_id,
                      staticClass: "users-row user",
                      class: {
                        selected:
                          _vm.selectedSmbUser === null &&
                          user.user_id === _vm.selectedUser.user_id,
                      },
                    },
                    [
                      _c("div", { staticClass: "users-row-email" }, [
                        _c(
                          "span",
                          {
                            staticStyle: {
                              position: "absolute",
                              left: "-30px",
                              color: "#999",
                            },
                          },
                          [
                            _c("font-awesome-icon", {
                              attrs: { icon: "user" },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "a",
                          {
                            staticClass: "user-email",
                            on: {
                              click: function ($event) {
                                return _vm.selectUser(user)
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(user.email) +
                                "\n            "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        user.user_id === _vm.location.owner_id
                          ? _c(
                              "small",
                              {
                                staticStyle: { color: "#999", float: "right" },
                              },
                              [_vm._v("\n              (Owner)\n            ")]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "manage-user-link" },
                          [
                            _c("add-user-location", {
                              attrs: {
                                "user-id": user.user_id,
                                location: _vm.location,
                                users: _vm.ownerUsers,
                                devices: _vm.devices,
                              },
                              on: {
                                selected: function ($event) {
                                  return _vm.selectUser(user)
                                },
                              },
                            }),
                          ],
                          1
                        ),
                      ]),
                    ]
                  )
                }),
                _vm._v(" "),
                _vm.nonOwnerUsers.length > 0
                  ? _c(
                      "div",
                      { staticClass: "ring-card__title non-owner-title" },
                      [_vm._v("\n          Other Users\n        ")]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm._l(_vm.nonOwnerUsers, function (user) {
                  return _c(
                    "div",
                    {
                      key: user.user_id,
                      staticClass: "users-row user",
                      class: {
                        selected: user.user_id === _vm.selectedUser.user_id,
                      },
                    },
                    [
                      _c("div", { staticClass: "users-row-email" }, [
                        _c(
                          "span",
                          {
                            staticStyle: {
                              position: "absolute",
                              left: "-30px",
                              color: "#999",
                            },
                          },
                          [
                            _c("font-awesome-icon", {
                              attrs: { icon: "user" },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "a",
                          {
                            staticClass: "user-email",
                            on: {
                              click: function ($event) {
                                return _vm.selectUser(user)
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(user.email) +
                                "\n            "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "small",
                          { staticStyle: { color: "#999", float: "right" } },
                          [
                            _vm._v(
                              "\n              (" +
                                _vm._s(user.role) +
                                ")\n            "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "manage-user-link" },
                          [
                            _c("add-user-location", {
                              attrs: {
                                "user-id": user.user_id,
                                location: _vm.location,
                                users: _vm.users,
                                devices: _vm.devices,
                              },
                              on: {
                                selected: function ($event) {
                                  return _vm.selectUser(user)
                                },
                              },
                            }),
                          ],
                          1
                        ),
                      ]),
                    ]
                  )
                }),
                _vm._v(" "),
                _vm.smbUsers.length > 0
                  ? _c(
                      "div",
                      { staticClass: "ring-card__title non-owner-title" },
                      [_vm._v("\n          Authorized Users\n        ")]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm._l(_vm.smbUsers, function (user, index) {
                  return _c(
                    "div",
                    {
                      key: "smb-" + index + "-" + user.user_id,
                      staticClass: "users-row user",
                      class: { selected: _vm.selectedSmbUser === user },
                    },
                    [
                      _c("div", { staticClass: "users-row-email" }, [
                        _c(
                          "span",
                          {
                            staticStyle: {
                              position: "absolute",
                              left: "-30px",
                              color: "#999",
                            },
                          },
                          [
                            _c("font-awesome-icon", {
                              attrs: { icon: "user" },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "a",
                          {
                            staticClass: "user-email",
                            on: {
                              click: function ($event) {
                                return _vm.selectUser(user)
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(user.email) +
                                "\n            "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "small",
                          { staticStyle: { color: "#999", float: "right" } },
                          [
                            _vm._v(
                              "\n              (" +
                                _vm._s(
                                  _vm.getRBACRoleDescription(user.role_name)
                                ) +
                                ")\n            "
                            ),
                          ]
                        ),
                      ]),
                    ]
                  )
                }),
              ],
              2
            ),
            _vm._v(" "),
            _c("el-col", { attrs: { span: 8 } }, [
              _c("div", { staticClass: "email" }, [
                _vm._v(
                  "\n          " + _vm._s(_vm.selectedUser.email) + "\n        "
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "ring-card__title" }, [
                _vm._v("\n          Devices\n        "),
              ]),
              _vm._v(" "),
              _c("div", { staticStyle: { padding: "10px 0px" } }, [
                _vm.userSelectedDevices.length > 0
                  ? _c(
                      "div",
                      _vm._l(_vm.userSelectedDevices, function (device, index) {
                        return _c(
                          "div",
                          { key: index, staticClass: "devices-row" },
                          [
                            _c("device-location-row", {
                              attrs: {
                                device: device,
                                "user-role": _vm.selectedUser.roleName,
                              },
                            }),
                          ],
                          1
                        )
                      }),
                      0
                    )
                  : _c(
                      "div",
                      [
                        _c("el-alert", {
                          attrs: {
                            title: "No devices for this user",
                            type: "info",
                            center: "",
                            "show-icon": "",
                          },
                        }),
                      ],
                      1
                    ),
              ]),
            ]),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }